<template>
  <div class="video">
      <img class="gifBtn" @click="bigThanBig" src="@/assets/img/cloud.gif" alt="" />
    <!-- 拌合楼小视频 -->
    <div
      class="mixingPlant"
      @click="enlargeMixingP"
      v-show="mixingPlantMin && mOpen"
      ref="mixingPlant"
    >
    <!-- 视频 -->
          <EasyPlayer
            id="test1"
            :videoUrl="t1"
            fluent
            :poster="img1"
            autoplay
            live
            stretch
            :aspect="windowWidth"
          ></EasyPlayer>
    </div>
    <!-- 前场小视频 -->
    <div class="fronCourt" ref="fronCourt" v-show="fronCourtMin && fOpen" @click="enlargeFronC">
      <!-- 小视频里小云图 -->
      <!-- <div class="cloudImg" ref="cloudImg">
        <iframe
          ref="iframe"
          id="bdIframe"
          :src="bdTokenUrl"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div> -->
      <EasyPlayer
            id="test1"
            :videoUrl="t2"
            fluent
            :poster="img2"
            autoplay
            live
            stretch
            :aspect="windowWidth"
          ></EasyPlayer>
    </div>
    <!-- 视屏放大 -->
    <div class="enlargeVideo" v-show="!mixingPlantMin || !fronCourtMin">
      <!-- 关闭按钮 -->
      <div class="close" @click="close">X</div>
      <!-- 放大视频 -->
      <div class="videos" v-show="!cloudImgFlag">
        <!-- 大视频里的小云图 -->
        <!-- <div class="cloudImgMax" ref="cloudImgMax" v-show="!fronCourtMin">
          <div class="mantle" @click="enlargeCloud"></div>
          <iframe
            ref="IframeMax"
            id="bdIframeMax"
            :src="bdTokenUrl1"
            frameborder="0"
            scrolling="no"
          ></iframe>
        </div> -->
         <div class="cloudImgMax1" ref="cloudImgMax" v-if="isCanMove">
          <div class="btnL" ><i @click="moveCameraGo(2)" class="el-icon-caret-left"></i></div>
          <div class="btnR" ><i @click="moveCameraGo(3)" class="el-icon-caret-right"></i></div>
          <div class="btnT" ><i @click="moveCameraGo(0)" class="el-icon-caret-top"></i></div>
          <div class="btnB" ><i @click="moveCameraGo(1)" class="el-icon-caret-bottom"></i></div>
        </div>
        <EasyPlayer
            id="test1"
            :videoUrl="t"
            fluent
            :poster="img"
            autoplay
            live
            stretch
            :aspect="windowWidth"
          ></EasyPlayer>
      </div>
      <!-- 放大云图 -->
      <!-- <div class="cloudImgM" ref="cloudImgM" v-show="cloudImgFlag">
        <iframe
          ref="IframeM"
          id="bdIframeM"
          :src="bdTokenUrl2"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div> -->
    </div>
    <div class="cloudImgMBox" v-show="cloudImgFlag">
      <div class="cloudImgM" ref="cloudImgM">
        <div @click="closeCloud" class="closeCloud"><i class="el-icon-close"></i></div>
        <iframe
          ref="IframeM"
          id="bdIframeM"
          :src="bdTokenUrl2"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import { getChannels, getImgUrl, touchchannelstream,getRealChannel,getAppKey,moveCameraR } from "@/api/api";
import { mapState } from "vuex";
import EasyPlayer from "@easydarwin/easyplayer";
export default {
  props: {},
  components: {
    EasyPlayer,
  },
  data() {
    return {
      bdTokenUrl: "",//三个不同大小云图的地址
      bdTokenUrl1: "",
      bdTokenUrl2: "",
      mixingPlantMin: true,//拌合楼视频是否放大
      fronCourtMin: true,//前场视频是否放大
      cloudImgFlag: false,//云图是否放大
      baseUrl:"http://119.45.190.236:10800",
      t1:'',
      img1:'',
      t2:'',
      img2:'',
      t:'',
      img:'',
      windowWidth:'',
      mOpen: false,
      fOpen: false,
      materialType: 'lq',
      channelM:'',
      channelF:'',
      intervalId: null,
      tokenStr:'',
      direction:'',
      deviceSerial:'',
      channelNo:'',
      isCanMove:false
    };
  },
  created() {},
  mounted() {
    let that = this;
    this.dataRefreh()
    this.getAppKeys()
    console.log('route',this.$route.path)
    if(this.$route.path.indexOf("lq") >= 0) {
        this.materialType = "lq"
      }else {
        this.materialType = "sw"
      }
  },
  methods: {
    // 获取萤石appKey
    async getAppKeys() {
       const ertData = await getAppKey();
      console.log(ertData)
      this.tokenStr = ertData.data
    },
     // 移动镜头
    async moveCameraGo(val) {
       let req = {
       accessToken:this.tokenStr,
       deviceSerial:this.deviceSerial,
       channelNo:this.channelNo,
       direction:val,
       speed:1,
       type:1
      };
      const ertData = await moveCameraR(req);
      console.log(ertData)
      if(ertData.status == 200) {
        setTimeout(() => {
          this.moveCameraStop(val)
        }, 500);
      }
    },
     // 停止镜头
    async moveCameraStop() {
       let req = {
       accessToken:this.tokenStr,
       deviceSerial:this.deviceSerial,
       channelNo:this.channelNo,
       direction:this.direction,
       speed:1,
       type:2
      };
      const ertData = await moveCameraR(req);
      console.log(ertData)
    },
    // 获取监控视频列表
    async getRealChannels(val) {
       let req = {
        engineeringId: this.engineerId,
        workareaId:this.sectionId,
        site:val  //1前2后
      };
      const ertData = await getRealChannel(req);
      console.log(ertData)
      if(val == 1) {
        this.t2 = ertData.data[0].url
        // this.t1 = ertData.data[0].url
      }else if(val == 2) {
        this.t1 = ertData.data[0].url
      }
      this.t = ertData.data[0].url
      this.deviceSerial = ertData.data[0].serialNumber,
      this.channelNo = ertData.data[0].channel,
      this.isCanMove = ertData.data[0].isPtz == 1?true:false
    },
    generateTimestampId() {
  const timestamp = Date.now().toString();
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let rand = '';

  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    // 浏览器安全随机
    const arr = new Uint32Array(16);
    crypto.getRandomValues(arr);
    for (const n of arr) rand += chars[n % chars.length];
  } else {
    try {
      // Node.js 安全随机
      const { randomBytes } = require('crypto');
      const buf = randomBytes(16);
      for (const n of buf) rand += chars[n % chars.length];
    }catch (e){
      // 兜底
      for (let i = 0; i < 16; i++) rand += chars[Math.floor(Math.random() * chars.length)];
    }
  }

  return timestamp + rand;
},
    bigThanBig() {
      let that = this;
      this.cloudImgFlag = true
      that.$nextTick(function () {
        let oIframeM = document.getElementById("bdIframeM");
        let deviceWidthM = that.$refs.cloudImgM.offsetWidth;
        let deviceHeightM = that.$refs.cloudImgM.offsetHeight;
        oIframeM.style.width = Number(deviceWidthM) - 2 + "px"; //数字是页面布局宽度差值
        oIframeM.style.height = Number(deviceHeightM) - 2 + "px"; //数字是页面布局高度差
        // this.workAreaId = 348
        // this.engineerId = 266
        // this.sectionId = 256
        // this.isHistory = 'realTime1'
        // this.materialType = 'lq'
        let time = '2021-04-15'
        console.log(this.materialType)
        // &source=3
        that.bdTokenUrl2 =
          // `http://218.2.99.139:15710/?workArea=${this.sectionId}&engineerId=${this.engineerId}&sectionId=${this.seIds}&isHistory=realTime&materialType=${this.materialType}&time=${time}&machineType=13&authkey=${this.generateTimestampId()}`;
          `http://cloudvue.jsti-smart.cn/?workArea=${this.sectionId}&engineerId=${this.engineerId}&sectionId=${this.seIds}&isHistory=realTime&materialType=${this.materialType}&time=${time}&machineType=13&authkey=${this.generateTimestampId()}`;
        //  that.bdTokenUrl2 =
        //   `http://59.110.143.238:1088/?workArea=348&engineerId=266&sectionId=${this.sectionId}&isHistory=realTime&materialType=sw&time=${time}&machineType=13`;
        console.log(that.bdTokenUrl2)
      });
    },
    closeCloud() {
    this.cloudImgFlag = false
    },
    //获取视频图片和地址
    async getVideo() {
      let that = this
      let req = {
        workareaId : this.sectionId
      }
      this.$nextTick(function() {
          let width = this.$refs.mixingPlant.offsetWidth || this.$refs.fronCourt.offsetWidth
          let height = this.$refs.mixingPlant.offsetHeight || this.$refs.fronCourt.offsetHeight
          this.windowWidth = width + ":" + height
        })
      const data = await getChannels(req);
      console.log(data)
      if(this.mOpen) {
        this.channelM = data.data.filter((item) => item.site.indexOf("后") >= 0)[0].channel;
        let per = {
          channel: this.channelM
        }
        const imgData = await getImgUrl(per);
        this.img1 = this.baseUrl + imgData.data.SimpleNVR.Body.Channels[0].SnapURL;
        // this.t1 = `${this.baseUrl}/flv/hls/stream_${this.channelM}.flv`

      }

      if(this.fOpen) {
        this.channelF = data.data.filter((item) => item.site.indexOf("前") >= 0)[0].channel;
        let per = {
          channel: this.channelF
        }
        const imgData = await getImgUrl(per);
        this.img2 = this.baseUrl + imgData.data.SimpleNVR.Body.Channels[0].SnapURL;
        // this.t2 = `${this.baseUrl}/flv/hls/stream_${this.channelF}.flv`
        //获取小视频显示大小
        const oIframe = document.getElementById("bdIframe");
        console.log('材料类型',this.materialType)
        that.$nextTick(function () {
          const deviceWidth = that.$refs.cloudImg.offsetWidth;
          const deviceHeight = that.$refs.cloudImg.offsetHeight;
          oIframe.style.width = Number(deviceWidth) - 2 + "px"; //数字是页面布局宽度差值
          oIframe.style.height = Number(deviceHeight) - 2 + "px"; //数字是页面布局高度差
          that.bdTokenUrl =
            `http://59.110.143.238:1088/?workArea=${this.sectionId}&engineerId=${this.engineerId}&sectionId=${this.sectionId}&isHistory=realTime&materialType=${this.materialType}&source=1`;
        });

      }
    },
    //保活接口
    isOnline() {
        if(this.mOpen) {
          let par = {
            channel:this.channelM,
            protocol:'FlV'
          }
          touchchannelstream(par)
        }
        if(this.fOpen){
          let par = {
            channel:this.channelF,
            protocol:'FlV'
          }
          touchchannelstream(par)
        }
    },
    dataRefreh() {
      let that = this
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return;
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        this.isOnline()
      }, 30000);
    },
    //放大拌合楼视频
    enlargeMixingP() {
      this.mixingPlantMin = false;
      this.t = this.t1
      this.img = this.img1
    },
    //放大前场视频
    enlargeFronC() {
      let that = this;
      that.fronCourtMin = false;
      this.t = this.t2
      this.img = this.img2
      //获取大视频里小云图大小
      let oIframeM = document.getElementById("bdIframeMax");
      that.$nextTick(function () {
        let deviceWidthM = that.$refs.cloudImgMax.offsetWidth;
        let deviceHeightM = that.$refs.cloudImgMax.offsetHeight;
        oIframeM.style.width = Number(deviceWidthM) - 2 + "px"; //数字是页面布局宽度差值
        oIframeM.style.height = Number(deviceHeightM) - 2 + "px"; //数字是页面布局高度差
        that.bdTokenUrl1 =
          "http://59.110.143.238:1088/?workArea=${this.workAreaId}&engineerId=${this.engineerId}&sectionId=${this.sectionId}&isHistory=realTime&materialType=${this.materialType}&source=2";
      });
    },
    //放大云图
    enlargeCloud() {
      let that = this;
      this.cloudImgFlag = true;
      //设置大云图大小
      that.$nextTick(function () {
        let oIframeM = document.getElementById("bdIframeM");
        let deviceWidthM = that.$refs.cloudImgM.offsetWidth;
        let deviceHeightM = that.$refs.cloudImgM.offsetHeight;
        oIframeM.style.width = Number(deviceWidthM) - 2 + "px"; //数字是页面布局宽度差值
        oIframeM.style.height = Number(deviceHeightM) - 2 + "px"; //数字是页面布局高度差
        that.bdTokenUrl2 =
          "http://59.110.143.238:1088/?workArea=${this.workAreaId}&engineerId=${this.engineerId}&sectionId=${this.sectionId}&isHistory=realTime&materialType=${this.materialType}&source=3";
      });
      // 59.110.143.238:8088
    },
    close() {
      //关闭时判断打开时是视频还是云图
      if (this.cloudImgFlag) {
        this.cloudImgFlag = false;
      } else {
        this.mixingPlantMin = true;
        this.fronCourtMin = true;
      }
    },
  },
  computed: mapState([
    "engineerId",
    "sectionId",
    "workAreaId",
    "introduction",
    "Participation",
    "construction",
    "supervisor",
    "Design",
    "mixplantOpen",
    "fronCourOpen",
    "seIds"
  ]),
  watch: {
    engineerId(curVal, oldVal) {
    },
    sectionId(curVal, oldVal) {
    },
    workAreaId(curVal, oldVal) {
      this.getVideo()
    },
    mixplantOpen(curVal, oldVal) {
      console.log(curVal)
      console.log(this.mixingPlantMin)
      this.mOpen = curVal
      this.getRealChannels(2)
      if(this.mOpen) {
        this.getVideo()
      }
    },
    fronCourOpen(curVal, oldVal) {
      this.fOpen = curVal
      console.log(this.workAreaId)
      console.log(this.engineerId)
      this.getRealChannels(1)
      if(this.fOpen) {
        this.getVideo()
      }
    },
    $route(to,from){
      console.log(to.path);
      if(to.path.indexOf("lq") >= 0) {
        this.materialType = "lq"
      }else {
        this.materialType = "sw"
      }
      this.$store.commit("updataMixplantOpen", false);
      this.$store.commit("updataFronCourOpen", false);
      this.mOpen = false
      this.fOpen = false
    }
  },
};
</script>
<style lang="less" scoped>
/deep/.vjs-control-bar {
  display: none;
}
.mixingPlant,
.fronCourt {
  width: 211px;
  height: 135px;
  position: absolute;
  bottom: 40px;
  background-color: #fff;
  z-index: 999;
  border: 2px solid #000;
}
.mixingPlant {
  left: 30px;
  .cloudImgMax {
    width: 420px;
      height: 300px;
      border: 1px solid #000;
      position: absolute;
      top: 0;
      right: 0;
      box-sizing: border-box;
      z-index: 9;
      .btnL {

      }
      .btnR {

      }
      .btnT {

      }
      .btnB {

      }
      .mantle {
        width: 420px;
        height: 300px;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 999999;
      }
  }
}
.fronCourt {
  right: 30px;
}
.cloudImg {
  width: 70px;
  height: 50px;
  position: absolute;
  top: 0;
  right: 0;
  border: 1px solid #000;
  box-sizing: border-box;
  z-index: 9;
}
.enlargeVideo {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  .close {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 130px;
    right: 200px;
    font-size: 28px;
    text-align: center;
    line-height: 40px;
    border-radius: 50%;
    border: 3px solid #fff;
    color: #fff;
    // transform:rotate(45deg);
    // -webkit-transform:rotate(45deg);
    // -moz-transform:rotate(45deg);
  }
  .videos {
    width: 1266px;
    height: 810px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -622px;
    margin-top: -405px;
    background-color: #fff;
    border: 2px solid #000;
    .cloudImgMax1 {
       width: 200px;
      height: 200px;
      // border: 1px solid #000;
      position: absolute;
      top: 0;
      right: 0;
      box-sizing: border-box;
      z-index: 9;
       .btnL {
        position: absolute;
        top: 30%;
        font-size:100px;
        border-radius: 30px;
        color:#44F8FF;;
      }
      .btnR {
        position: absolute;
        font-size:100px;
        top: 30%;
        right:0;
        border-radius: 30px;
        color:#44F8FF;;
      }
      .btnT {
        position: absolute;
        font-size:100px;
        left:25%;
        color:#44F8FF;;
      }
      .btnB {
        position: absolute;
        font-size:100px;
        left:25%;
        bottom:-30px;
        color:#44F8FF;
      }
    }
    .cloudImgMax {
      width: 420px;
      height: 300px;
      border: 1px solid #000;
      position: absolute;
      top: 0;
      right: 0;
      box-sizing: border-box;
      z-index: 9;

      .mantle {
        width: 420px;
        height: 300px;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 999999;
      }
    }
  }
  .cloudImgM {
    width: 1266px;
    height: 810px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -622px;
    margin-top: -405px;
    background-color: #fff;
    border: 2px solid #000;
  }
}
.gifBtn {
  position:fixed;
  bottom: 200px;
  right: 30px;
  width: 140px;
  height: 140px;
}
.cloudImgMBox {
  width: 100%;
  height: 100%;
  position: fixed;
  top:0;
  left: 0;
  background-color: rgba(0,0,0,.6);
   z-index: 1002;
}
.cloudImgM {
    width: 1566px;
    height: 1010px;
    position: absolute;
    z-index: 1002;
    left: 50%;
    top: 50%;
    margin-left: -770px;
    margin-top: -505px;
    background-color: #fff;
    border: 2px solid #000;
  }
.closeCloud {
  position: absolute;
  right:-25px;
  top:-30px;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  background-color: #fff;
  border:1px splid #000;
  text-align: center;
  line-height: 50px;
  font-weight: 900;
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/subassembly/video.vue